module.exports = "https://trybtryb-legacy.web.app/img/noticeboard.1f93a44e.webp";